// extracted by mini-css-extract-plugin
export default {"row":"styles_row__3Vf6s"};